import { SalesOrderStatus } from '@rematter/frontend-lib-api-client';

import { OrderRecordForLink } from '../types/brokeredOrder';

import { orderDetailFragment } from './fragmentOrderDetails';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

const LINK_ORDERS_PAGE_SIZE = 50;

export const salesOrdersForLinkQueryAtom = createQueryAtomFactory(
  'brokerage.salesOrdersForLink',
  (params: { searchTerm?: string; accountIds?: string[] }) => ({
    salesOrders: {
      __args: {
        filter: {
          searchTerm: params.searchTerm || undefined,
          accountIds: params.accountIds,
        },
        pagination: {
          limit: LINK_ORDERS_PAGE_SIZE,
          offset: 0,
        },
      },
      entries: {
        ...orderDetailFragment,
        startDate: true,
        totalPrice: {
          amount: true,
          currencyCode: true,
        },
        lineItems: {
          id: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { orders: OrderRecordForLink[]; total: number } => ({
      orders: data.salesOrders.entries.map(
        (order): OrderRecordForLink => ({
          id: order.id,
          documentNumber: order.documentNumber,
          status: order.status as SalesOrderStatus,
          accountName: order.account?.name ?? 'Unknown',
          address: order.account?.addresses?.map((a) => ({
            id: a.id,
            ...a.address,
          })),
          startDate: order.startDate as string | null,
          total: order.totalPrice as OrderRecordForLink['total'],
          lineItems: order.lineItems,
        }),
      ),
      total: data.salesOrders.page.total ?? 0,
    }),
  },
);
